export default "__VITE_ASSET__DkPDQGZq__"